var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormUploadClip.jinja');
require('./SubmissionFormUploadClip.less');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'blur .SubmissionFormUploadClip-input': 'getVideoInfo',
        'keyup .SubmissionFormUploadClip-input': 'onVideoCodeKeyUp',
        'click .SubmissionFormUploadClip-preview': 'getVideoInfo'
    },

    embedApi: function () {
        return (UrlsFront['front:api:oembed']());
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this,  'embedApi');

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        this.videoXHR && this.videoXHR.abort();

        return SubmissionFormBlock.prototype.deactivate.call(this, params);
    },


    onVideoCodeKeyUp: function (e) {
        if (e.keyCode == 13) {
            this.getVideoInfo();
        }
    },


    getVideoInfo: function () {
        var $inputUrl = this.$('.SubmissionFormUploadClip-input');
        var $previewButton = this.$('.SubmissionFormUploadClip-preview');
        var $embed = this.$('.SubmissionFormUploadClip-embed');
        var self = this;

        $previewButton.addClass('Button--loading');
        $inputUrl.attr('data-code', '');

        this.videoXHR && this.videoXHR.abort();

        this.videoXHR = $.ajax({
            type: 'GET',
            url: this.embedApi(),
            dataType: 'json',
            data: {url: $inputUrl.val()},
            success: function (data) {
                if (!data || data.error) {
                    self.$('.SubmissionFormUploadClip-media').removeClass('SubmissionFormUploadClip-media--hasMedia');
                    $previewButton.removeClass('Button--loading');

                    return;
                }

                $inputUrl.attr('data-code', data.code);
                $inputUrl.attr('data-provider', data.provider);
                $inputUrl.attr('data-cover', data.cover.url);

                $embed.html(data.code);

                self.$('.SubmissionFormUploadClip-media').addClass('SubmissionFormUploadClip-media--hasMedia');
                $previewButton.removeClass('Button--loading');
            },
            error: function () {
                console.log(arguments);
                self.$('.SubmissionFormUploadClip-media').removeClass('SubmissionFormUploadClip-media--hasMedia');
                $previewButton.removeClass('Button--loading');
            }
        });
    },


    checkRequired: function () {
        return true;
    },


    getFormData: function () {
        var $inputUrl = this.$('.SubmissionFormUploadClip-input');
        var videoUrl = $inputUrl.val() || null;
        var videoCode = videoUrl ? $inputUrl.attr('data-code') : null;
        var videoCover = videoUrl ? $inputUrl.attr('data-cover') : null;

        return {
            'assetsVideoUrl': videoUrl,
            'assetsVideoCode': videoCode,
            'assetsVideoCover': videoCover
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormUploadClip.js
// module id = 125
// module chunks = 0